<template>
  <div
    v-tooltip.right="statusMapping[status] && statusMapping[status].tooltip"
    :class="statusMapping[status] && statusMapping[status].class"
  />
</template>

<script>
const mapping = {
  enabled: {
    class: 'green_status',
    tooltip: 'Feature Enabled'
  },
  disabled: {
    class: 'grey_status',
    tooltip: 'Feature Enabled'
  },
  deactivated: {
    class: 'red_status',
    tooltip: 'Deactivated'
  }
};

export default {
  props: {
    /* eslint-disable */
    // ngVue using default value instead of the passed value
    status: {
      type: String,
    }
    /* eslint-enable */
  },
  data() {
    return {
      statusMapping: {...mapping}
    };
  },
};
</script>

<style>

</style>